import * as React from "react";
import { styled, Tooltip } from "@mui/material";
import { GroundingFragment } from "fe-common/graphql";
import { ValidatedIndicator } from "../references/ValidatedIndicator";

//region [[ Styles ]]

const GroundingRagView = styled("div")({});
const FootNoteLink = styled("sup")(({ theme }) => ({
  marginLeft: 2,
  color: theme.palette.primary.main,
  cursor: "pointer",
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline",
  },
  "&:dir(rtl)": {
    marginLeft: 0,
    marginRight: 2,
  },
}));
const ValidateTextStyled = styled("div")({
  display: "flex",
  gap: 6,
  marginBottom: 6,
  alignItems: "center",
  color: "green",
  fontSize: 13,
  "& svg": { fill: "currentcolor", width: 16, height: 16 },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface GroundingRagProps {
  groundedData: GroundingFragment;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const GroundingRag = ({ groundedData }: GroundingRagProps) => {
  const sentences = groundedData.sentences;
  const notationsLocations: number[] = [];
  const words: string[] = [];
  const statements: string[] = [];

  for (const sentence of sentences) {
    const sentenceStatements = sentence?.statements;
    const sentenceText = sentence?.sentence;

    if (sentenceStatements) {
      for (const s of sentenceStatements) {
        notationsLocations.push(s.wordIndexForReferencePoint);
        statements.push(s.statement);
      }
    }
    if (sentenceText) words.push(...sentenceText.split(" "));
  }

  let statementIndex = -1;
  return (
    <GroundingRagView>
      {words.map((word, i) => {
        if (notationsLocations.includes(i)) {
          statementIndex++;
          return (
            <>
              {words[i]}
              <Tooltip
                key={`footnoteTip_${i}`}
                title={
                  <div>
                    <ValidatedIndicator />
                    <span className={"medium-tooltip multiline-tooltip"}>
                      {statements[statementIndex]}
                    </span>
                  </div>
                }
                placement="top"
                arrow
              >
                <FootNoteLink
                  key={`footnote${i}`}
                  //onClick={() => onFootnoteClick(s + "_" + i)}
                >
                  [{statementIndex + 1}]
                </FootNoteLink>
              </Tooltip>{" "}
            </>
          );
        } else {
          return words[i] + " ";
        }
      })}
    </GroundingRagView>
  );
};
